import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IAccount } from "src/domain/entities"
import { AccountListView } from "."

interface Props {
	list: IAccount[]
	isLoading: boolean
	onUpdate: (account: IAccount) => void
	onDelete: (account: IAccount) => void
	onAddClick: () => void
}

export const AccountListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No accounts found." onAddClick={onAddClick} />
	}

	return <AccountListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
